/**
 * DOS518 - Digital Operations System for Wildfire Management
 * 
 * Copyright (c) 2024-2025 Angelo Irtilaç
 * All rights reserved.
 * 
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, modification, or use is strictly prohibited.
 * 
 * ---
 * 
 * Author: Angelo Irtilaç
 * Qualifications: DOS (Direttore delle Operazioni di Spegnimento)
 *                39 years - Corpo Nazionale dei Vigili del Fuoco
 *                DOS Trainer & Instructor
 * 
 * Location: Carpi, Italy
 * Contact: [inserire email]
 * 
 * ---
 * 
 * This software implements official Italian Fire Department protocols:
 * - C.O.A.U. (Centro Operativo Aereo Unificato)
 * - SI.TA.C. (Sistema Tattico di Coordinamento)
 * - L.A.C.E.S. (Lookout, Awareness, Communication, Escape routes, Safety zones)
 * 
 * Developed with operational expertise acquired through decades of wildfire
 * emergency management and coordination of suppression operations.
 * 
 * For commercial licensing inquiries, please contact the author.
 */
// src/components/Risorse/RisorseManager.tsx
import React, { useState } from 'react';
import { PersonaleTab } from './PersonaleTab';
import { MezziTerrestriTab } from './MezziTerrestriTab';
import { MezziAereiTab } from './MezziAereiTab';
import { DroniTab } from './DroniTab';
import './RisorseManager.css';

type TabType = 'personale' | 'mezzi_terrestri' | 'mezzi_aerei' | 'droni';

export const RisorseManager: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('personale');

  return (
    <div className="risorse-manager">
      <div className="risorse-header">
        <h2>👥 Gestione Risorse</h2>
      </div>

      <div className="risorse-tabs">
        <button
          className={`tab-btn ${activeTab === 'personale' ? 'active' : ''}`}
          onClick={() => setActiveTab('personale')}
        >
          👤 Personale
        </button>
        <button
          className={`tab-btn ${activeTab === 'mezzi_terrestri' ? 'active' : ''}`}
          onClick={() => setActiveTab('mezzi_terrestri')}
        >
          🚛 Mezzi Terrestri
        </button>
        <button
          className={`tab-btn ${activeTab === 'mezzi_aerei' ? 'active' : ''}`}
          onClick={() => setActiveTab('mezzi_aerei')}
        >
          🚁 Mezzi Aerei
        </button>
        <button
          className={`tab-btn ${activeTab === 'droni' ? 'active' : ''}`}
          onClick={() => setActiveTab('droni')}
        >
          🛸 Droni
        </button>
      </div>

      <div className="risorse-content">
        {activeTab === 'personale' && <PersonaleTab />}
        {activeTab === 'mezzi_terrestri' && <MezziTerrestriTab />}
        {activeTab === 'mezzi_aerei' && <MezziAereiTab />}
        {activeTab === 'droni' && <DroniTab />}
      </div>
    </div>
  );
};
